import React, { FC } from "react";

import { Grid } from "@amphore-dev/amphore-lib";

import { DeleteAccountCard } from "@/components/organisms/DeleteAccountCard/DeleteAccountCard";
import { SubscriptionSummary } from "@/components/organisms/SubscriptionSection/SubscriptionSummary";

import { TUser } from "@/types";

/** The "Compte" tab: what the account costs, and how it ends. */
export const AccountTab: FC<{ me: TUser }> = ({ me }) => (
	<Grid className="w-full" columns={2} minItemWidth="400px">
		<SubscriptionSummary />
		<DeleteAccountCard hasPassword={me.hasPassword !== false} />
	</Grid>
);
